@if (commentsVisible || timelineVisible) {
  <pp-point-heading
    id="timelineHeading"
    (ppOnRendered)="onTimelineHeadingRendered($event)"
    data-m-target="Point timeline section"
  >
    @if (!commentsOnly) {
      <ng-container heading> {{ 'activity' | ppTranslate }} </ng-container>
    }
    @if (commentsOnly) {
      <ng-container heading> {{ 'comments' | ppTranslate }} </ng-container>
    }
    @if (commentsVisible && timelineVisible) {
      <ng-container secondary>
        <button
          class="timeline__activity-type"
          [ngClass]="{ 'timeline__activity-type--selected': !commentsOnly }"
          (click)="showAllActivities()"
        >
          {{ 'all' | ppTranslate }}
        </button>
        <button
          class="timeline__activity-type"
          [ngClass]="{ 'timeline__activity-type--selected': commentsOnly }"
          (click)="showCommentsOnly()"
        >
          {{ 'only_comments' | ppTranslate }}
        </button>
      </ng-container>
    }
  </pp-point-heading>
}

@if (!commentsOnly || (comments && comments.data.length > 0)) {
  <div
    class="timeline__container"
    [ngClass]="isBrowserSafari ? 'timeline__safariMobileSpacing' : ''"
  >
    @if (!commentsOnly) {
      @for (
        activityData of activityData.data;
        track activityData;
        let first = $first;
        let last = $last;
        let index = $index
      ) {
        <div class="timeline__activity">
          @if (commentsVisible || !(activityData.data.childRef?.type === 'DefectComment')) {
            <span class="timeline__avatar-wrapper">
              @if (!(activityData.header.createdBy.primaryImageId && !isAvatarDefault)) {
                <img
                  ppTooltip
                  class="timeline__avatar timeline__avatar--default"
                  draggable="false"
                  [src]="EIconPath.PLACEHOLDER_USER"
                  ppTitle="{{ activityData.header.createdBy.caption }}"
                />
              }
              @if (activityData.header.createdBy.primaryImageId && !isAvatarDefault) {
                <img
                  ppTooltip
                  ppImage
                  class="timeline__avatar"
                  draggable="false"
                  loading="lazy"
                  [ppSecureSrc]="
                    'api/v1/images/' +
                    activityData.header.createdBy.primaryImageId +
                    '/file/size/square/40'
                  "
                  (error)="showDefaultAvatar()"
                  ppTitle="{{
                    activityData.header.createdBy.caption ||
                      activityData.header.createdBy['userName']
                  }}"
                />
              }
            </span>
            @if (activityData.data.childRef?.type != 'DefectComment') {
              <div
                class="timeline__activity-item timeline__activity-item--other"
                [class.timeline__activity-item--last]="last"
              >
                <div class="timeline__activity-content">
                  <!-- new point activity -->
                  @if (activityData.activityType === 'NEW_DOCUMENT' && !activityData.data.comment) {
                    <span class="timeline__new-point">
                      <span class="activityChange__icon sw-icon sw-icon-new-point"></span>
                      <span>{{ 'added_this_point' | ppTranslate }}</span>
                    </span>
                  }
                  <!-- / new point activity end -->
                  <!-- relation activity -->
                  @if (activityData.data.relatedPointId) {
                    <div class="timeline__relation-activity" data-testid="relation-activity">
                      <span class="activityChange__icon">
                        <pp-icon
                          class="activityChange__icon-svg"
                          [ppSrc]="EIconPath.ICON_MISC_LINK_18"
                          ppClass="setSize18"
                          ppColor="inherit"
                        />
                      </span>
                      <div class="activityChange">
                        @if (activityData.data.action !== 'REMOVED') {
                          <span>
                            {{ 'activity_added_relationship' | ppTranslate }}
                            <strong>{{
                              relatedPointTypeLabelKey[activityData.data.relationshipType]
                                | ppTranslate
                            }}</strong>
                            for
                            <strong>{{ activityData.data.relatedPointTitle }}</strong
                            >.
                          </span>
                        }
                        @if (activityData.data.action === 'REMOVED') {
                          <span>
                            {{ 'activity_removed_relationship' | ppTranslate }}
                            <strong>{{
                              relatedPointTypeLabelKey[activityData.data.relationshipType]
                                | ppTranslate
                            }}</strong>
                            for
                            <strong>{{ activityData.data.relatedPointTitle }}</strong
                            >.
                          </span>
                        }
                      </div>
                    </div>
                  }
                  <!-- / relation activity end -->
                  <!-- other activities -->
                  @if (
                    activityData.data.changeList?.length > 0 &&
                    !(activityData.activityType === 'NEW_DOCUMENT')
                  ) {
                    @for (
                      change of activityData.data.changeList;
                      track change;
                      let index = $index
                    ) {
                      <div class="timeline__activity-change">
                        @if (
                          !change.propName ||
                          ((change.propName !== 'description' ||
                            ((activityData.data.changeList[index + 1]?.propName !==
                              'descriptionRich' ||
                              (activityData.data.changeList[index + 1]?.propName ===
                                'descriptionRich' &&
                                activityData.data.changeList[index + 1]?.newValue !== '' &&
                                !activityData.data.changeList[index + 1]?.newValue)) &&
                              (index - 1 < 0 ||
                                activityData.data.changeList[index - 1]?.propName !==
                                  'descriptionRich' ||
                                (activityData.data.changeList[index - 1]?.propName ===
                                  'descriptionRich' &&
                                  activityData.data.changeList[index - 1]?.newValue !== '' &&
                                  !activityData.data.changeList[index - 1]?.newValue)))) &&
                            (change.propName !== 'descriptionRich' ||
                              (change.propName === 'descriptionRich' && change.newValue)))
                        ) {
                          <pp-activity-change
                            [ppChange]="change"
                            [ppVersion]="fetchedActivitiesVersion"
                            [ppCustomFieldId]="change.cfTemplateId"
                            [ppWorkspaceId]="ppWorkspaceId"
                            [ppAuthor]="activityData.header.createdBy.caption"
                          ></pp-activity-change>
                        }
                      </div>
                    }
                  }
                  <!-- / other activities end -->
                </div>
                <div
                  ppTooltip
                  [ppTitle]="activityData.header.timeStampHover"
                  class="timeline__activity-datetime hide--mobile"
                >
                  {{ activityData.header.formattedDatetime }}
                  <i aria-hidden="true" class="fa fa-clock timeline__activity-datetime-icon"></i>
                </div>
              </div>
            }
            @if (activityData.data.childRef?.type === 'DefectComment') {
              <pp-comment-activity
                [ppLast]="last"
                [ppComment]="activityData"
                [ppShareOption]="workspace?.share.shareOption"
                [ppPointId]="ppPointId"
              ></pp-comment-activity>
            }
          }
        </div>
      }
    }
    @if (commentsOnly && comments.data.length > 0) {
      @for (comment of comments.data; track comment; let last = $last; let index = $index) {
        <div class="timeline__activity">
          <span class="timeline__avatar-wrapper">
            <img
              [src]="EIconPath.PLACEHOLDER_USER"
              class="timeline__avatar"
              draggable="false"
              [hidden]="comment.header.createdBy.primaryImageId"
            />
            @if (comment.header.createdBy.primaryImageId) {
              <img
                ppTooltip
                ppImage
                class="timeline__avatar"
                draggable="false"
                loading="lazy"
                [ppSecureSrc]="
                  'api/v1/images/' +
                  comment.header.createdBy.primaryImageId +
                  '/file/size/square/40'
                "
                ppTitle="{{ comment.header.createdBy.caption }}"
              />
            }
          </span>
          <pp-comment-activity
            [ppLast]="last"
            [ppComment]="comment"
            [ppShareOption]="workspace?.share.shareOption"
            [ppPointId]="ppPointId"
          ></pp-comment-activity>
        </div>
      }
    }
    @if (processing || !ppDetailsFetched) {
      <pp-point-activity-placeholder></pp-point-activity-placeholder>
    }
    <div class="timeline__load-more-button-container">
      @if (
        activityData.pageNumber < activityData.pagination?.totalPages &&
        activityData.fetched &&
        !commentsOnly
      ) {
        <pp-button
          ppStyle="secondary"
          ppId="timelineLoadMoreBtn"
          (ppAction)="loadMore()"
          ppSize="small"
          [ppDisabled]="ppAttachmentUploading"
          [ppProcess]="processing"
        >
          {{ 'load_more' | ppTranslate }}
        </pp-button>
      }
    </div>
  </div>
}

@if (commentsOnly && comments && !(comments.data.length > 0) && !processing) {
  <div class="timeline__no-content">
    <div class="timeline__no-content-icon">
      <span class="activityChange__icon timeline__no-content-icon--inner">
        <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_COMMENT" />
      </span>
    </div>
    {{ 'no_comments_found_1' | ppTranslate }}
    <strong>{{ 'no_comments_found_2' | ppTranslate }}</strong>
    {{ 'no_comments_found_3' | ppTranslate }}
  </div>
}

@if (!timelineVisible) {
  <div class="timeline__no-timeline"></div>
}
